/**
 * Created by sagil on 10/10/2016.
 */
import {Component, Output, EventEmitter, Input} from "@angular/core";

@Component({
	selector: 'cp-popup-buttons-ok',
	template : `
		<cp-button-strip>
			<div class="primary-area">
				<cp-button-widget-custom class="primary-button"
										 [titleToTranslate]="okLabel ? okLabel : 'OK'"
										 [isDisabled]="okDisabled"
										 (onClick)="okDisabled ? null : ok.emit();">
				</cp-button-widget-custom>
			</div>
		</cp-button-strip>
`
})
export class PopupButtonsOkComponent {
	@Input() okDisabled: boolean;
	@Input() okLabel: string;

	@Output() ok = new EventEmitter();
}
